import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';

import { FINANCE_RESOURCES } from '../../helper';
import EditConfig from './submodules/edit';
import { DOWNTIMEMANAGEMENT_RESOURCES } from '../downtimeManagementHelper';
import { UPI_DOWNTIME_MANAGEMENT_PAGE_NAME } from './utils/constant';

const DowntimeManagementUpiDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.downtimeManagement}
				configResourceName={DOWNTIMEMANAGEMENT_RESOURCES.upi}
				configActionName={UPI_DOWNTIME_MANAGEMENT_PAGE_NAME}
				path={`${path}/edit`}
				component={EditConfig}
				exact
			/>
			<Redirect to={`${path}/edit`} />
		</Switch>
	);
};

export default DowntimeManagementUpiDashboard;
